import { render, staticRenderFns } from "./xyxs.vue?vue&type=template&id=81c3e930&scoped=true"
import script from "./xyxs.vue?vue&type=script&lang=js"
export * from "./xyxs.vue?vue&type=script&lang=js"
import style0 from "./xyxs.vue?vue&type=style&index=0&id=81c3e930&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c3e930",
  null
  
)

export default component.exports